package uz.ferro.shop.error

class HttpException(
    val code: Int,
    val errorResponse: String
) : RuntimeException("Response error")